// Import 3rd-party dependencies
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

// Import project-specific dependencies
import { CLOCK_SETTINGS_TAB_COMPONENT_CONSTS } from '@app/config/constants';

export interface IClockSettingsTabData {
  dateFormat: string;
  timeFormat: string;
  showDayOfWeek: boolean;
}

@Component({
  selector: 'app-clock-settings-tab',
  templateUrl: './clock-settings-tab.component.html',
  styleUrls: ['./clock-settings-tab.component.css']
})
export class ClockSettingsTabComponent implements OnInit {
  // Class attributes
  today: Date;
  @Input() settings: IClockSettingsTabData;
  @Output() changeSettings: EventEmitter<IClockSettingsTabData>;

  consts = CLOCK_SETTINGS_TAB_COMPONENT_CONSTS;

  // Class methods
  constructor() {
    this.changeSettings = new EventEmitter<IClockSettingsTabData>();
  }

  ngOnInit(): void {
    // Initialization
    this.today = new Date();
  }

  onSettingsChanged(): void {
    this.changeSettings.emit(this.settings);
  }
}
